module.exports = __webpack_public_path__ + "img/stent-trimming.76344c63.jpg";